import { render } from "./HomeBlocks.vue?vue&type=template&id=6d7e2982"
import script from "./HomeBlocks.vue?vue&type=script&lang=js"
export * from "./HomeBlocks.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__